import styles from './AddCustomerPage.module.scss';
import popStyles from '../../../components/popup/PopupModel.module.scss';
import icnimage from 'assets/images/icn-image.svg';
import icnvideo from 'assets/images/icn-video.svg';
import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import LoadingIndicator from '../../../components/loading-indicator/LoadingIndicator';
import SideBanner from '../../components/side-banner/SideBanner';
import { addCustomerActions, commonActions, countryAction } from '../../../../stores/_actions';
import Label from '../../../../constants/Label';
import Validator from '../../../common/common-functions';
import * as moment from 'moment';
import { PopupModel } from '../../../components/popup/PopupModel';
import { InputBox } from '../../../components/InputBox/InputBox';
import { DateInput } from '../../../components/DateInput/DateInput';
import { PasswordBox } from '../../../components/PasswordInput/PasswordInput';
import { Dropdown } from '../../../components/Dropdown/Dropdown';
import { ListItem } from '../../../components/ListItem/ListItem';
import axios from 'axios';
import environment from 'environment';
import popClose from 'assets/images/pop-close.svg';

function AddCustomerPage() {
  // let filesize = '';
  const customerData = localStorage.getItem('customer');
  const customerCodeData = localStorage.getItem('CustomerCode');
  const iskycenabled = localStorage.getItem('iskycenabled');
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  const errInlineStyle = { 'align-self': 'flex-end', 'margin-left': '-32%', 'margin-bottom': '-4px' };
  const relStyle = { position: 'relative' };
  const absStyle = { position: 'absolute' };

  const location = useLocation();
  const history = useHistory();
  const payload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      FirstName: '',
      MiddleName: null,
      LastName: '',
      Email: '',
      IDNo: '',
      IDType: '',
      MobileNo: '',
      DOB: '',
      Password: '',
      DeviceID: '',
      DeviceType: 'WEB',
      Addr1: '',
      Addr2: '',
      Addr3: null,
      IDIssueCountry: '',
      Nationality: '',
      ProfessionID: '',
      IDIssueDate: '',
      IDExpiryDate: '',
      IdImageFront: '',
      IdImageBack: '',
      POBox: '',
    },
    Status: false,
    SessionID: null,
    IdType: null,
  };

  const payload2 = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {},
    Status: false,
    SessionID: null,
    Langcode: null,
  };
  const Mob = JSON.parse(customerData)?.MobileNo.replace(/(\d{3})(\d{8})/, '+$1-$2');
  const mobile_num = Mob?.replace(/[^0-9]/g, '');
  const [fimage, setFrontImage] = useState('');
  const [bimage, setBackImage] = useState('');
  const [filesize, setFileSize] = useState('');
  const [customer, setCustomer] = useState({
    FirstName: '',
    LastName: '',
    Email: '',
    IDNo: JSON.parse(customerData)?.IDNO,
    IDType: '',
    MobileNo: Mob,
    DOB: '',
    POBox: '',
    Password: 'Null',
    IDIssueCountry: '',
    Nationality: '',
    DeviceID: JSON.parse(customerData)?.IDNO,
    Address1: '',
    Address2: '',
    Profession: '',
    IDIssueDate: '',
    IDExpiryDate: '',
    IdImageFront: '',
    IdImageBack: '',
  });

  const clientList = [
    {
      ID: '00001',
      Type: '',
      Description: 'Emirate',
      CurrencyFlagPath: '',
      ImagePath: null,
    },
    {
      ID: '00002',
      Type: '',
      Description: 'Quater',
      CurrencyFlagPath: '',
      ImagePath: null,
    },
  ];

  // reset customer status
  const [submitted, setSubmitted] = useState(false);
  const [modelPopup, openPopup] = useState(false);
  const dispatch = useDispatch();
  const CountryID = '';
  useEffect(() => {
    // !sessionId ? history.push('/') : history.push('/home');
    dispatch(commonActions.nationality());
    dispatch(commonActions.country());
    dispatch(addCustomerActions.getIDType());
    dispatch(addCustomerActions.getProfession(payload2));
    localStorage.removeItem('term');
    localStorage.removeItem('registervalue');
  }, []);

  const [incCountry1, setIncCountry1] = useState('ID Issue Country');
  const [country1, setStyleCountry1] = useState('');

  const selectCountry1Name = (event, items) => {
    setStyleCountry1(!country1);
    setIncCountry1((incCountry1) => (incCountry1 = items.Description));
    setCustomer((customer) => ({ ...customer, IDIssueCountry: items.ID }));
    // CountryID = items.ID;
  };

  const [incCountry, setIncCountry] = useState('Nationality');
  const [incGetId, setGetId] = useState('ID Type');
  const [idCountry, setIdCountry] = useState('ID Issue Country');
  const [Profession, setProfessionId] = useState('Profession');

  const [country, setStyleCountry] = useState(false);
  const [idIssueCountry, setIssueCountry] = useState(false);

  const [idtype, setIDType] = useState(false);
  const [professionType, setProfession] = useState('');
  const [incClientId, setClientId] = useState('Select Client');
  const [clientType, setClientType] = useState(false);
  const nationaList = useSelector((state) => state.nationality?.data);
  const countryList = useSelector((state) => {
    if (state.country) {
      if (state.country.data) {
        if (state.country.data.length) return state.country?.data;
      }
    }
  });

  const getProfessionList = useSelector((state) => state.getProfession?.data);
  const idList = useSelector((state) => state.getIDType?.data);
  let errorMsg = '';
  let errorMsgPin = '';
  let errorMsgMail = '';
  let errorMsgIdno = '';
  let errorMsgPassword = '';
  let errorMsgiDate = '';
  let errorMsgexDate = '';
  let errorMsgFirstName = '';
  let errorMsgLastName = '';
  let errorAdd1Msg = '';
  let errorAdd2Msg = '';

  const handleChange = (e) => {
    setCustomer((customer) => ({ ...customer, errorMsg: '' }));
    // setCustomer((customer) => ({ ...customer, errorMsgPin: '' }));

    const { name, value } = e.target;
    if (name == 'IDIssueDate' && value) {
      const issueDate = new Date(value).getTime();
      const today = new Date().getTime();
      setCustomer((customer) => ({ ...customer, IDIssueDate: '', errorMsgiDate: '' }));
      if (today < issueDate) {
        customer.IDIssueDate = '';
        setCustomer((customer) => ({ ...customer, IDIssueDate: '' }));
        errorMsgiDate = 'Invalid issue date!';
        setCustomer((customer) => ({ ...customer, errorMsgiDate: errorMsgiDate }));
        return;
      }
    }
    if (name == 'IDExpiryDate' && value != '') {
      const expDate = new Date(value).getTime();
      const today = new Date().getTime();
      setCustomer((customer) => ({ ...customer, IDExpiryDate: '', errorMsgexDate: '' }));
      if (today > expDate) {
        customer.IDExpiryDate = '';
        setCustomer((customer) => ({ ...customer, IDExpiryDate: '' }));
        errorMsgexDate = 'ID Expiry date is before issue date';
        setCustomer((customer) => ({ ...customer, errorMsgexDate: errorMsgexDate }));
        return;
      }
    }
    if (name == 'MobileNo') {
      if (!value) {
        setCustomer((customer) => ({ ...customer, errorMsg: 'Mobile number is required' }));
        return;
      }
      if (value.length > 8) return;
      setCustomer((customer) => ({ ...customer, errorMsg: '' }));
      const checkNumber = Validator.digitsOnly(value);
      if (!checkNumber) {
        errorMsg = 'Mobile Number field supports only Numerics.';
        setCustomer((customer) => ({ ...customer, MobileNo: customer.prevMobNo }));
        // setCustomer((customer) => ({ ...customer, [name]: '' }));
        setCustomer((customer) => ({ ...customer, errorMsg: errorMsg }));
        return;
      }
      customer.prevMobNo = value;
    }
    if (name == 'FirstName') {
      setCustomer((customer) => ({ ...customer, errorMsgFirstName: '' }));

      const checkNumber = Validator.nameValidate(value);
      if (!checkNumber) {
        errorMsgFirstName = 'Please enter valid First Name';
        if (!customer.prevFirstName) {
          setCustomer((customer) => ({ ...customer, FirstName: value, errorMsgFirstName: errorMsgFirstName }));
        } else {
          setCustomer((customer) => ({ ...customer, FirstName: customer.prevFirstName, errorMsgFirstName: errorMsgFirstName }));
          return;
        }
      }
      customer.prevFirstName = value;
    }
    if (name == 'LastName') {
      if (customer.prevFirstName == '') setCustomer((customer) => ({ ...customer, [name]: value }));
      setCustomer((customer) => ({ ...customer, errorMsgLastName: '' }));
      const checkNumber = Validator.nameValidate(value);
      if (!checkNumber) {
        errorMsgLastName = 'Please enter valid Last Name';
        if (!customer.prevLastName) {
          setCustomer((customer) => ({ ...customer, LastName: value, errorMsgLastName: errorMsgLastName }));
        } else {
          setCustomer((customer) => ({ ...customer, LastName: customer.prevLastName, errorMsgLastName: errorMsgLastName }));
          return;
        }
      }
      customer.prevLastName = value;
    }
    if (name == 'POBox') {
      setCustomer((customer) => ({ ...customer, POBox: value, errorMsgPin: '' }));
    }
    if (name == 'Email') {
      setCustomer((customer) => ({ ...customer, errorMsgMail: '' }));
      // if (!value || customer.prevEmail) {
      //   let checkEmail = Validator.emailValidator(value);
      //   if (!checkEmail) {
      //     errorMsgMail = 'Enter valid Email ID';
      //     setCustomer((customer) => ({ ...customer, [name]: customer.prevEmail }));
      //     setCustomer((customer) => ({ ...customer, errorMsgMail: errorMsgMail }));
      //     return;
      //   }
      // } else customer.prevEmail = value;
    }
    if (name == 'IDNO') {
      setCustomer((customer) => ({ ...customer, errorMsgIdno: '' }));
      if (value.length > 12) return;
      const checkNumber = Validator.digitsOnly(value);
      if (!checkNumber) {
        errorMsgIdno = 'KUWAIT CIVIL ID Number should be Numeric';
        setCustomer((customer) => ({ ...customer, [name]: customer.prevIDNo }));
        setCustomer((customer) => ({ ...customer, errorMsgIdno: errorMsgIdno }));
        return;
      }
      if (value.length > 12) {
        errorMsgIdno = 'KUWAIT CIVIL ID Number length should be of 12 digits only';
        setCustomer((customer) => ({ ...customer, errorMsg: errorMsgIdno }));
        return;
      }
      customer.prevIDNo = value;
      customer.IDNO = value;
      setCustomer((customer) => ({ ...customer, [name]: value }));
    }
    if (name == 'Password') {
      setCustomer((customer) => ({ ...customer, errorMsgPassword: '' }));
      const checkNumber = Validator.alphanumberic(value);
      if (!checkNumber) {
        errorMsgPassword = 'Password field supports only Alphanumeric.';
        setCustomer((customer) => ({ ...customer, [name]: customer.prevPassword }));
        setCustomer((customer) => ({ ...customer, errorMsgPassword: errorMsgPassword }));
        return;
      }
      if (value.length > 12) {
        errorMsgPassword = 'Password length should be of 12 digits only';
        setCustomer((customer) => ({ ...customer, errorMsg: errorMsgPassword }));
        return;
      }
      customer.prevPassword = value;
      customer.Password = value;
      setCustomer((customer) => ({ ...customer, [name]: value }));
    }
    setCustomer((customer) => ({ ...customer, [name]: value }));
  };

  const selectCountryName = (event, items) => {
    setStyleCountry(!country);
    setIncCountry((incCountry) => (incCountry = items.Description));
    setCustomer((customer) => ({ ...customer, Nationality: items.ID }));
  };

  const selectIdIssueCountryName = (event, items) => {
    setIssueCountry(!idIssueCountry);

    setIdCountry((idCountry) => (idCountry = items.Description));
    setCustomer((customer) => ({ ...customer, IDIssueCountry: items.Description }));
  };

  const selectGetId = (event, items) => {
    setIDType(!idtype);
    setGetId((incGetId) => (incGetId = items.Description));
    setCustomer((customer) => ({ ...customer, IDType: items.ID }));
  };

  const selectClient = (event, items) => {
    setClientType(!clientType);
    setClientId((incClientId) => (incClientId = items.Description));
    setCustomer((customer) => ({ ...customer, IDType: items.ID }));
  };

  const selectGetProfession = (event, items) => {
    setProfession(!professionType);
    setProfessionId((Profession) => (Profession = items.Description));
    setCustomer((customer) => ({ ...customer, Profession: items.Description, ProfessionID: items.ID }));
  };
  function formData(file, doctype, custCode) {
    const endpoint = environment.api.uploadMedia;
    const form_data = new FormData();
    form_data.append('Image', file, file.name);
    form_data.append('DocType', doctype);
    form_data.append('CustomerCode', custCode);
    // let url = 'http://103.121.26.154:91/kuwait/mobremitclient/api/admin/UploadMedia';
    axios
      .post(endpoint, form_data, {
        headers: {
          'content-type': 'multipart/form-data',
          'Content-Type': 'image/jpeg',
        },
      })
      .then((res) => {})
      .catch((err) => console.log(err));
  }

  function imageValidation(file, face) {
    if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/svg+xml') {
      face == 'IDFront' ? setFrontImage('') : setBackImage('');
    } else {
      //face == 'IDFront' ? customer.imgErr1 = 1 : customer.imgErr2 = 1

      const message = 'Invalid image format, Please upload only jpg, png, jpeg files';
      face == 'IDFront' ? setFrontImage((fimage) => (fimage = message)) : setBackImage((bimage) => (bimage = message));
      // setFileSize((filesize)  => (filesize = 'invalid image format, Please upload only jpg, png, jpeg files'));
      return;
    }
  }

  function imageSizeValidation(file) {
    if (file.size > 2000000) {
      setFileSize((filesize) => (filesize = 'file size is greater then 2MB'));
      return;
    }
  }

  const [file1, setFile1] = useState(null);
  const [file2, setFile2] = useState(null);

  const onFrontImageChange = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    setFile1(file);
    imageValidation(file, 'IDFront');
    imageSizeValidation(file);
    // formData(file, 'IDFront');
    setTimeout(() => {
      setCustomer((customer) => ({ ...customer, IdImageFront: file.name }));
    }, 100);
  };
  const imgBackErr = '';
  const onBackImageChange = (event) => {
    event.preventDefault();
    setCustomer((customer) => ({ ...customer, imgBackErr: '' }));
    const file = event.target.files[0];
    setFile2(file);
    imageValidation(file, 'IDBack');
    imageSizeValidation(file);
    // formData(file, 'IDBack');
    setTimeout(() => {
      setCustomer((customer) => ({ ...customer, IdImageBack: file.name }));
    }, 100);
  };

  const handleSubmit = (event, form) => {
    event.preventDefault();
    setSubmitted(true);
    if (customer.POBox) {
      setCustomer((customer) => ({ ...customer, errorMsgPin: '' }));
      const checkNumber = Validator.alphanumberic(customer.POBox);
      if (customer.POBox.replace(/\s/g, '') === '') {
        errorMsgPin = 'PoBox should be Alphanumeric';
        setCustomer((customer) => ({ ...customer, errorMsgPin: errorMsgPin }));
      } else if (!checkNumber) {
        errorMsgPin = 'PoBox should be Alphanumeric';
        setCustomer((customer) => ({ ...customer, errorMsgPin: errorMsgPin }));
      }
    }
    if (customer.FirstName) {
      setCustomer((customer) => ({ ...customer, errorMsgFirstName: '' }));
      const checkNumber = Validator.nameValidate(customer.FirstName);
      if (checkNumber && customer.FirstName.replace(/\s/g, '') === '') {
        errorMsgFirstName = 'Please enter valid First Name';
        setCustomer((customer) => ({ ...customer, errorMsgFirstName: errorMsgFirstName }));
      } else if (!checkNumber) {
        errorMsgFirstName = 'Please enter valid First Name';
        setCustomer((customer) => ({ ...customer, errorMsgFirstName: errorMsgFirstName }));
      }
    }
    if (customer.LastName) {
      setCustomer((customer) => ({ ...customer, errorMsgLastName: '' }));
      const checkNumber = Validator.nameValidate(customer.LastName);
      if (checkNumber && customer.LastName.replace(/\s/g, '') === '') {
        errorMsgLastName = 'Please enter valid Last Name';
        setCustomer((customer) => ({ ...customer, errorMsgLastName: errorMsgLastName }));
      } else if (!checkNumber) {
        errorMsgLastName = 'Please enter valid Last Name';
        setCustomer((customer) => ({ ...customer, errorMsgLastName: errorMsgLastName }));
      }
    }
    if (customer.Address1) {
      setCustomer((customer) => ({ ...customer, errorMsgAdd1: '' }));
      const checkNumber = Validator.addressValidator(customer.Address1);
      if (checkNumber && customer.Address1.replace(/\s/g, '') === '') {
        errorAdd1Msg = 'Address 1 should be Alphanumeric';
        setCustomer((customer) => ({ ...customer, errorAdd1Msg: errorAdd1Msg }));
      } else if (!checkNumber) {
        errorAdd1Msg = 'Address 1 should be Alphanumeric!';
        setCustomer((customer) => ({ ...customer, errorAdd1Msg: errorAdd1Msg }));
      }
    }
    if (customer.Address2) {
      setCustomer((customer) => ({ ...customer, errorAdd2Msg: '' }));
      const checkNumber = Validator.addressValidator(customer.Address2);
      if (checkNumber && customer.Address2.replace(/\s/g, '') === '') {
        errorAdd2Msg = 'Address 2 should be Alphanumeric';
        setCustomer((customer) => ({ ...customer, errorAdd2Msg: errorAdd2Msg }));
      } else if (!checkNumber) {
        errorAdd2Msg = 'Address 2 should be Alphanumeric!';
        // setCustomer((customer) => ({ ...customer, POBox: customer.prevPOBox }));
        setCustomer((customer) => ({ ...customer, errorAdd2Msg: errorAdd2Msg }));
      }
    }
    if (customer.Email) {
      setCustomer((customer) => ({ ...customer, errorMsgMail: '' }));
      // if (!customer.Email || customer.prevEmail) {
      const checkEmail = Validator.emailValidator(customer.Email);
      if (!checkEmail) {
        errorMsgMail = 'Enter valid Email ID';
        setCustomer((customer) => ({ ...customer, [customer.Email.name]: customer.prevEmail }));
        setCustomer((customer) => ({ ...customer, errorMsgMail: errorMsgMail }));
      }
      // } else customer.prevEmail = customer.Email;
    }
    if (bimage || fimage) {
      return;
    }
    if (!customer.MobileNo) {
      setCustomer((customer) => ({ ...customer, errorMsg: 'Mobile Number is required' }));
      return;
    }
    if (
      customer.MobileNo.replace(/\s/g, '') !== '' &&
      customer.IDNo.replace(/\s/g, '') !== '' &&
      customer.FirstName.replace(/\s/g, '') !== '' &&
      customer.LastName.replace(/\s/g, '') !== '' &&
      customer.Email.replace(/\s/g, '') !== '' &&
      // customer.IDType &&
      //customer.Password &&
      customer.Nationality.replace(/\s/g, '') !== '' &&
      customer.Address1.replace(/\s/g, '') !== '' &&
      customer.Address2.replace(/\s/g, '') !== '' &&
      // customer.IDIssueDate &&
      customer.IDExpiryDate.replace(/\s/g, '') !== '' &&
      // customer.POBox &&
      customer.Profession.replace(/\s/g, '') !== '' &&
      // customer.IDIssueCountry &&
      customer.IdImageBack.replace(/\s/g, '') !== '' &&
      customer.IdImageFront.replace(/\s/g, '') !== ''
    ) {
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
      let issueDate = new Date(customer.IDIssueDate);
      if (customer.IDIssueDate) {
        issueDate = `${issueDate.getDate()}/${months[issueDate.getMonth()]}/${issueDate.getFullYear()}`;
      }
      let expiryDate = new Date(customer?.IDExpiryDate);
      expiryDate = `${expiryDate.getDate()}/${months[expiryDate.getMonth()]}/${expiryDate.getFullYear()}`;
      let dob = new Date(customer?.DOB);
      dob = `${dob.getDate()}/${months[dob.getMonth()]}/${dob.getFullYear()}`;

      payload.Data['FirstName'] = customer?.FirstName;
      payload.Data['LastName'] = customer?.LastName;
      payload.Data['Email'] = customer?.Email;
      payload.Data['IDNo'] = customer?.IDNo;
      // payload.Data['IDType'] = customer?.IDType;
      payload.Data['MobileNo'] = mobile_num;
      payload.Data['DeviceID'] = customer?.IDNo;
      // payload.Data['IDIssueCountry'] = customer?.IDIssueCountry;
      payload.Data['Nationality'] = customer?.Nationality;
      payload.Data['DOB'] = dob;
      payload.Data['Addr1'] = customer?.Address1;
      payload.Data['Addr2'] = customer?.Address2;
      payload.Data['POBox'] = customer?.POBox;
      payload.Data['Profession'] = customer?.Profession;
      payload.Data['ProfessionID'] = customer?.ProfessionID;
      // payload.Data['IDIssueDate'] = issueDate;
      payload.Data['IDExpiryDate'] = expiryDate;
      payload.Data['IdImageFront'] = customer?.IdImageFront;
      payload.Data['IdImageBack'] = customer?.IdImageBack;
      dispatch(addCustomerActions.addCustomer(payload));
      openPopup(true);
    }
  };

  const minDate = moment(new Date())
    .add(1, 'day')
    .format('YYYY-MM-DD');
  const maxDate = moment(new Date()).format('YYYY-MM-DD');
  const age = moment(new Date())
    .subtract(18, 'years')
    .format('YYYY-MM-DD');

  let result;
  useSelector((state) => (result = state.addCustomer?.data));

  const url = ['/', '/add-customer'];

  const hidePopup = () => {
    openPopup(false);
    if (result.statusCode === '200') {
      formData(file1, 'IDFront', result?.response?.CustomerCode);
      formData(file2, 'IDBack', result?.response?.CustomerCode);
    }
    result.statusCode == '200' ? history.push({ pathname: '/', state: {} }) : history.push({ pathname: '/add-customer', state: {} });
  };
  const searchText = (e) => {
    e.preventDefault();
    let input, filter, ul, a, i, txtValue;
    input = document.getElementById(`mySearch${e.target.name}`);
    filter = input.value.toUpperCase();
    ul = document.getElementById(e.target.name);
    a = ul.getElementsByTagName('a');
    for (i = 0; i < a.length; i++) {
      txtValue = a[i].innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        a[i].style.display = '';
      } else {
        a[i].style.display = 'none';
      }
    }
  };
  return (
    <LoadingIndicator>
      <div className={styles.LoginPage}>
        <SideBanner />
        <div className={styles.LoginPage__loginform}>
          <h1>{Label.AddCustomer.heading}</h1>
          <form name="customer" autoComplete="none" onSubmit={(event) => handleSubmit(event, customer)}>
            <div className={styles.LoginPage__formgroup}>
              <InputBox
                type="text"
                styles={styles}
                handleChange={handleChange}
                data={customer.FirstName}
                name="FirstName"
                placeholder="First Name"
                error={customer.errorMsgFirstName}
                submitted={submitted}
                className="mandatory"
              />
              <InputBox
                type="text"
                styles={styles}
                handleChange={handleChange}
                data={customer.LastName}
                name="LastName"
                error={customer.errorMsgLastName}
                placeholder="Last Name"
                submitted={submitted}
                className="mandatory"
              />
              {/* <div style={relStyle}> */}
              <InputBox
                type="text"
                styles={styles}
                max="8"
                min="8"
                handleChange={handleChange}
                data={customer.MobileNo}
                name="MobileNo"
                placeholder="Mobile Number"
                submitted={submitted}
                readOnly={true}
              />
              {/* <div className={styles.dropdown} style={absStyle}>
                <button type="button">
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAMCAYAAABm+U3GAAAABHNCSVQICAgIfAhkiAAAAMdJREFUOE9jLCgo+M9AA8AIMri/vx9u9Pf3HxkuL9/CcHLSYobvbz8wMDIykmzts2gLBgyD39x+wHCgbhLD/f0nGBj+kecZrAZ/ffuB4dKi9Qynp69g+PH+I/Vc/PvHT4a7Ow4z7G+YxPD56SvqGfzx8XOGY73zGK6v3cXw58dP6hn86dkLhhMTFjNcXbmV4fe3H9QzmGZB8eX1O4YL89YwnJuzmuHHh8/Uc/Hbu48YDjVNZbiz6wjD/z9/qWcwVTMIyVmLCA0AVyqcwdi1jjoAAAAASUVORK5CYII=" />+{Label.Register.mobileCountryCode}
                </button>
                <div className={styles.dropdown__droppop}>
                  <a href="#">item</a>
                </div>
              </div> */}
              {/* </div> */}
              {/* <div className={styles.LoginPage__error}>{customer.errorMsg}</div> */}
              {/* <PasswordBox
                type="password"
                max="8"
                styles={styles}
                handleChange={handleChange}
                data={customer.Password}
                name="Password"
                placeholder="Transaction Password"
                maxLength="8"
                submitted={submitted}
              />
              {customer.errorMsgPassword ? <p className={styles.LoginPage__error}>{customer.errorMsgPassword}</p> : ''} */}
              {customer.errorMsgPassword ? (
                <span className={styles.LoginPage__error} style={errInlineStyle}>
                  {customer.errorMsgPassword}
                </span>
              ) : (
                ''
              )}
              <DateInput
                type="text"
                styles={styles}
                max={age}
                handleChange={handleChange}
                data={customer.DOB}
                name="DOB"
                placeholder="Date Of Birth"
                submitted={submitted}
                className="mandatory"
              />
              {/* <Dropdown
                type="button"
                styles={styles}
                handleChange={handleChange}
                name="ID Issue Country"
                list={countryList}
                data={idCountry}
                value={idIssueCountry}
                selection={setIssueCountry}
                action={selectIdIssueCountryName}
                submitted={submitted}
                notRequired={true}
              /> */}
              <Dropdown
                type="button"
                styles={styles}
                handleChange={handleChange}
                name="Nationality"
                list={nationaList}
                data={incCountry}
                value={country}
                selection={setStyleCountry}
                action={selectCountryName}
                submitted={submitted}
                className="mandatory"
              />
              <InputBox
                type="text"
                styles={styles}
                handleChange={handleChange}
                data={customer.POBox}
                min="6"
                max="8"
                name="POBox"
                placeholder="Pin/POBox"
                error={customer.errorMsgPin}
                submitted={submitted}
                notRequired={true}
              />
              {/* <div className={styles.LoginPage__error}>{customer.errorMsgPin}</div> */}
              <InputBox
                type="text"
                styles={styles}
                handleChange={handleChange}
                data={customer.Address1}
                name="Address1"
                placeholder="Address 1"
                error={customer.errorAdd1Msg}
                submitted={submitted}
                className="mandatory"
              />
              <InputBox
                type="text"
                styles={styles}
                handleChange={handleChange}
                data={customer.Address2}
                name="Address2"
                error={customer.errorAdd2Msg}
                placeholder="Address 2"
                submitted={submitted}
                className="mandatory"
              />
              <InputBox
                type="text"
                styles={styles}
                handleChange={handleChange}
                data={customer.Email}
                name="Email"
                placeholder="Email"
                submitted={submitted}
                error={customer.errorMsgMail}
                className="mandatory"
              />
              {/* {customer.errorMsgMail ? (
                <span className={styles.LoginPage__error} style={errInlineStyle}>
                  {customer.errorMsgMail}
                </span>
              ) : (
                ''
              )} */}
              {/* <div className={styles.LoginPage__error}>{customer.errorMsgMail}</div> */}
              {/* <Dropdown
                type="button"
                styles={styles}
                handleChange={handleChange}
                name="ID Type"
                list={idList}
                data={incGetId}
                value={idtype}
                selection={setIDType}
                action={selectGetId}
                submitted={submitted}
                className="mandatory"
              /> */}
              <InputBox
                type="text"
                max="12"
                styles={styles}
                handleChange={handleChange}
                data={customer.IDNo}
                name="IDNo"
                placeholder="ID No"
                submitted={submitted}
                readOnly={true}
              />
              {/* <div className={styles.LoginPage__error}>{customer.errorMsgIdno}</div> */}
              <Dropdown
                type="button"
                styles={styles}
                handleChange={handleChange}
                name="Profession"
                list={getProfessionList}
                data={Profession}
                value={professionType}
                selection={setProfession}
                action={selectGetProfession}
                submitted={submitted}
                className="mandatory"
              />

              {/* <DateInput
                type="text"
                styles={styles}
                max={maxDate}
                handleChange={handleChange}
                data={customer.IDIssueDate}
                name="IDIssueDate"
                placeholder="ID Issue Date"
                submitted={submitted}
                notRequired={true}
              /> */}
              {customer.errorMsgiDate ? (
                <span className={styles.LoginPage__error} style={errInlineStyle}>
                  {customer.errorMsgiDate}
                </span>
              ) : (
                ''
              )}
              <DateInput
                type="text"
                styles={styles}
                min={minDate}
                handleChange={handleChange}
                data={customer.IDExpiryDate}
                name="IDExpiryDate"
                placeholder="ID Expiry Date"
                submitted={submitted}
                className="mandatory"
              />
              {customer.errorMsgexDate ? (
                <span className={styles.LoginPage__error} style={errInlineStyle}>
                  {customer.errorMsgexDate}
                </span>
              ) : (
                ''
              )}
              {JSON.parse(iskycenabled) == 'Y' ? (
                <div className={styles.LoginPage__formBox}>
                  <div className={styles.LoginPage__formBox__imageBox}>
                    <p style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} className="mandatory">
                      <input type="file" name="IdImageFront" value="" onChange={onFrontImageChange} icon="image" />
                      {customer.IdImageFront ? customer.IdImageFront : 'ID Front Image'} <img src={icnimage} />
                    </p>
                    {!customer.IdImageFront && submitted ? <div className={styles.LoginPage__error}>ID Front Image is required</div> : ''}
                    {customer.IdImageFront && fimage != null ? <div className={styles.LoginPage__error}>{fimage}</div> : ''}
                  </div>
                </div>
              ) : (
                ''
              )}
              {JSON.parse(iskycenabled) == 'Y' ? (
                <div className={styles.LoginPage__formBox}>
                  <div className={styles.LoginPage__formBox__imageBox}>
                    <p style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} className="mandatory">
                      <input type="file" name="IdImageBack" value="" onChange={onBackImageChange} icon="image" />
                      {customer.IdImageBack ? customer.IdImageBack : 'ID Back image'} <img src={icnimage} />
                    </p>
                    {customer.IdImageBack && bimage != null ? <div className={styles.LoginPage__error}>{bimage}</div> : ''}
                    {!customer.IdImageBack && submitted ? <div className={styles.LoginPage__error}>ID Back image is required</div> : ''}
                  </div>
                </div>
              ) : (
                ''
              )}
              {/* <p>For UAE clients</p> */}
              {/* <a href="#">
                ID ImageFront <img src={icnvideo} />
              </a> */}
              {/* <div className={styles.LoginPage__formBox}>
                <div className={styles.dropdown}>
                  <button type="button">{incClientId}</button>
                  <div className={styles.dropdown__droppop + ` ` + `${clientType ? styles.show : styles.hide}`}>
                    {clientList ? <ListItem list={clientList} action={selectClient}/> : <h4> Loading ...</h4> }
                    </div>
                </div>
              </div>   */}
              {/* <Dropdown
                type="button"
                styles={styles}
                handleChange={handleChange}
                name="Client Type"
                list={clientList}
                data={incClientId}
                value={clientType}
                selection={setClientType}
                action={selectClient}
                submitted={submitted}
              /> */}
              <span></span>
            </div>
            {/* <a className={styles.LoginPage__link} href="#">
          {Label.AddCustomer.buttonLabel}
          </a> */}
            <a href="/" className={styles.LoginPage__link}>
              Cancel
            </a>
            <input type="submit" value={Label.AddCustomer.buttonLabel} className={styles.LoginPage__link} />
          </form>
          {modelPopup ? (
            <div className={popStyles.dialogue}>
              <div className={popStyles.dialogue__wrap}>
                <img className={popStyles.dialogue__close} src={popClose} onClick={hidePopup} />
                <p>{result?.message}</p>
                <div className={popStyles.dialogue__buttons}>
                  <Link onClick={hidePopup}>OK</Link>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    </LoadingIndicator>
  );
}

export { AddCustomerPage };
